import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { SLAReport } from "../../subscription-detail/sla-report/sla-report";

@Component({
  selector: "dialog-sls",
  templateUrl: "dialog-sls.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, SLAReport, TranslatePipe],
})
export class DialogSls {
  private dialogRef = inject(MatDialogRef<DialogSls>);
  private data = inject<{ customerDescription?: string | null; description: string; subscriptionId: string }>(
    MAT_DIALOG_DATA,
  );

  protected presentableName = this.data.customerDescription ?? this.data.description;
  protected subscriptionId = this.data.subscriptionId;

  protected closeDialog() {
    this.dialogRef.close();
  }
}
